import React, { useState, useEffect, useRef } from 'react';
import { Chapter } from '../../services/novelService';
import './ChapterEditor.css';

interface ChapterEditorProps {
  chapter: Chapter;
  onContentUpdate: (chapterId: string, content: string) => void;
}

const ChapterEditor: React.FC<ChapterEditorProps> = ({
  chapter,
  onContentUpdate
}) => {
  const [content, setContent] = useState('');
  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Load chapter content when chapter changes
    if (chapter.content?.text_value) {
      setContent(chapter.content.text_value);
    } else {
      setContent('');
    }
  }, [chapter]);

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newContent = e.target.value;
    setContent(newContent);

    // Auto-save after 1 second of no typing
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
      onContentUpdate(chapter.chapter_id, newContent);
    }, 1000);
  };

  return (
    <div className="chapter-editor">
      <div className="chapter-editor-content-wrapper">
        <textarea
          className="chapter-editor-content"
          value={content}
          onChange={handleContentChange}
          placeholder="Start writing your chapter..."
        />
      </div>
    </div>
  );
};

export default ChapterEditor;

